"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CACHE_PREFIX = 'service-awards:';
// cached for 5 minute
var CACHE_DURATION = 5;
function SDK(baseUrl, fetch, cacheInterface, ignorePromises, cacheDurationMinutes) {
  // Private
  function fetchJson(url) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, res, _res, data, text;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      if (options && options.body) {
        options.headers = _objectSpread(_objectSpread({}, options.headers || {}), {}, _defineProperty({}, 'content-type', 'application/json'));
      }
      // some of the sdks are used in the browswer where the native fetch is used.
      if (typeof window === 'undefined') {
        options.responseType = 'json';
        return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_7) {
          try {
            res = $await_7;
            return $return(res.body);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      } else {
        return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_8) {
          try {
            _res = $await_8;
            if (_res.ok) {
              return Promise.resolve(_res.json()).then($return, $error);
            } else {
              if (_res.headers.get('content-type').indexOf('application/json') !== -1) {
                return Promise.resolve(_res.json()).then(function ($await_10) {
                  try {
                    data = $await_10;
                    return $error(_objectSpread({
                      status: _res.status
                    }, data));
                  } catch ($boundEx) {
                    return $error($boundEx);
                  }
                }, $error);
              }
              return Promise.resolve(_res.text()).then(function ($await_11) {
                try {
                  text = $await_11;
                  return $error(text);
                } catch ($boundEx) {
                  return $error($boundEx);
                }
              }, $error);
            }
            return $If_1.call(this);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }.bind(this), $error);
      }
      function $If_1() {
        return $return();
      }
      return $If_1.call(this);
    });
  }

  // use whatever is passed in or set to default
  cacheDurationMinutes = cacheDurationMinutes || CACHE_DURATION;
  var _getKey = function _getKey(key) {
    return cacheInterface.getKey(CACHE_PREFIX, key);
  };
  var _cacheGet = function _cacheGet(key) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      if (options.hardRefresh) {
        return $return(undefined);
      }
      return Promise.resolve(cacheInterface.get(_getKey(key))).then($return, $error);
    });
  };
  var _cacheSet = function _cacheSet(key, value, duration) {
    return cacheInterface.set({
      key: _getKey(key),
      value: value,
      lifetimeMins: duration ? duration : cacheDurationMinutes
    });
  };
  var _cacheSetPromise = function _cacheSetPromise(key, value) {
    if (ignorePromises) {
      return value;
    }
    return cacheInterface.set({
      key: _getKey(key),
      value: value,
      isPromise: true,
      lifetimeMins: cacheDurationMinutes
    });
  };
  var _cacheClearByKeyStartsWith = function _cacheClearByKeyStartsWith(partialKey) {
    return new Promise(function ($return, $error) {
      return $return(cacheInterface.clearByKeyStartsWith(_getKey(partialKey)));
    });
  };
  var _clearByKey = function _clearByKey(key) {
    return cacheInterface.clearByKey(_getKey(key));
  };

  // Contributors
  function getContributors(celebrationId, personIds) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, BATCH_SIZE, batches, i, contributorMap, nonCachedPersonIds, _i, contributors, _i2, contributor, key;
      // create a helper function to check the cache and add it to either the map or the list
      function checkCache(personId) {
        return new Promise(function ($return, $error) {
          var key, cached;
          key = "contributors-".concat(celebrationId, "-").concat(personId);
          return Promise.resolve(_cacheGet(key, options)).then(function ($await_13) {
            try {
              cached = $await_13;
              if (cached) {
                contributorMap[personId] = cached;
              } else {
                nonCachedPersonIds.push(personId);
              }
              return $return();
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        });
      }
      // go through the batches and check the cache
      options = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      if (!Array.isArray(personIds)) {
        personIds = [];
      }
      // create batches so calls to the cache happen in parallel
      BATCH_SIZE = 10;
      batches = [];
      for (i = 0; i < personIds.length; i += BATCH_SIZE) {
        batches.push(personIds.slice(i, i + BATCH_SIZE));
      }
      // keep a mapping of cached contributors and a list of non cached personIds
      contributorMap = {};
      nonCachedPersonIds = [];
      _i = 0;
      var $Loop_4_trampoline;
      function $Loop_4_step() {
        _i += 1;
        return $Loop_4;
      }
      function $Loop_4() {
        if (_i < batches.length) {
          return Promise.resolve(Promise.all(batches[_i].map(function (personId) {
            return checkCache(personId);
          }))).then(function ($await_14) {
            try {
              return $Loop_4_step;
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } else return [1];
      }
      return ($Loop_4_trampoline = function (q) {
        while (q) {
          if (q.then) return void q.then($Loop_4_trampoline, $error);
          try {
            if (q.pop) {
              if (q.length) return q.pop() ? $Loop_4_exit.call(this) : q;else q = $Loop_4_step;
            } else q = q.call(this);
          } catch (_exception) {
            return $error(_exception);
          }
        }
      }.bind(this))($Loop_4);
      function $Loop_4_exit() {
        if (nonCachedPersonIds.length === 0 && personIds.length > 0) {
          contributors = [];
          return $If_6.call(this);
        } else {
          return Promise.resolve(fetchJson("/celebration/".concat(encodeURIComponent(celebrationId), "/contributors"), {
            method: 'POST',
            body: JSON.stringify({
              personIds: nonCachedPersonIds
            })
          })).then(function ($await_15) {
            try {
              contributors = $await_15;
              return $If_6.call(this);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }.bind(this), $error);
        }
        // go through the contributors and add them to the cache
        function $If_6() {
          for (_i2 = 0; _i2 < contributors.length; _i2++) {
            contributor = contributors[_i2];
            contributorMap[contributor.personId] = contributor;
            key = "contributors-".concat(celebrationId, "-").concat(contributor.personId);
            _cacheSet(key, contributor);
          }
          // return the contributors
          return $return(Object.values(contributorMap));
        }
      }
    });
  }
  function getContributorsInvitationDate(celebrationId, rosterPersonIds) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      key = "contributors-invitation-date-".concat(celebrationId, "-").concat(rosterPersonIds ? rosterPersonIds.toString() : '');
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_16) {
        try {
          cached = $await_16;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/celebration/".concat(encodeURIComponent(celebrationId), "/contributors/invitation-date"), {
            method: 'POST',
            body: JSON.stringify({
              rosterPersonIds: rosterPersonIds
            })
          });
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_17) {
            try {
              response = $await_17;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getInvitee(contributionId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "invitee-".concat(contributionId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_18) {
        try {
          cached = $await_18;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/contributions/".concat(encodeURIComponent(contributionId)), {
            method: 'GET'
          });
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_19) {
            try {
              response = $await_19;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function addContributorsToCelebrationFromEmail(celebrationId, contributors, notify) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson("/celebration/".concat(encodeURIComponent(celebrationId), "/contributors/email?notify=").concat(notify ? 'true' : 'false'), {
        method: 'POST',
        body: JSON.stringify(contributors)
      })).then(function ($await_20) {
        try {
          response = $await_20;
          // don't hold up response by awaiting
          _cacheClearByKeyStartsWith("contributors-".concat(celebrationId));
          _cacheClearByKeyStartsWith('contributors-invitation-date');
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function addContributorsToCelebrationFromRosterId(celebrationId, contributors, notify) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson("/celebration/".concat(encodeURIComponent(celebrationId), "/contributors/roster?notify=").concat(notify ? 'true' : 'false'), {
        method: 'POST',
        body: JSON.stringify(contributors)
      })).then(function ($await_21) {
        try {
          response = $await_21;
          // don't hold up response by awaiting
          _cacheClearByKeyStartsWith("contributors-".concat(celebrationId));
          _cacheClearByKeyStartsWith('contributors-invitation-date');
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function createOrUpdateContributor(celebrationId, person) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson("/celebration/".concat(encodeURIComponent(celebrationId), "/contributors"), {
        method: 'PUT',
        body: JSON.stringify(person)
      })).then(function ($await_22) {
        try {
          response = $await_22;
          return Promise.resolve(_cacheClearByKeyStartsWith('invitee')).then(function ($await_23) {
            try {
              // don't hold up response by awaiting
              _cacheClearByKeyStartsWith("contributors-".concat(celebrationId));
              _cacheClearByKeyStartsWith('contributors-invitation-date');
              return $return(response);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function acceptTermsAndConditions(celebrationId, personId) {
    var response = fetchJson("/celebration/".concat(encodeURIComponent(celebrationId), "/contributors/").concat(encodeURIComponent(personId), "/terms-and-conditions"), {
      method: 'POST'
    });

    // don't hold up response by awaiting
    _cacheClearByKeyStartsWith('invitee');
    return response;
  }
  function createOrUpdateCelebrationReplies(celebrationId, commentId, notificationData) {
    var request = {
      celebrationId: celebrationId,
      commentId: commentId,
      notificationData: notificationData
    };
    return fetchJson('/celebration-replies', {
      method: 'POST',
      body: JSON.stringify(request)
    });
  }
  function deleteCelebrationReplies(commentId) {
    return fetchJson("/celebration-replies/".concat(encodeURIComponent(commentId)), {
      method: 'DELETE'
    });
  }

  // Programs
  function getPrograms() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
      key = 'programs';
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_24) {
        try {
          cached = $await_24;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson('/programs');
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_25) {
            try {
              response = $await_25;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function saveProgram(program) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson('/programs', {
        method: 'POST',
        body: JSON.stringify(program)
      })).then(function ($await_26) {
        try {
          response = $await_26;
          if (program.programId) {
            _clearByKey("program-".concat(program.programId));
          } else {
            _clearByKey('programs');
          }
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getProgram(programId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "program-".concat(programId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_27) {
        try {
          cached = $await_27;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/programs/".concat(encodeURIComponent(programId)));
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_28) {
            try {
              response = $await_28;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function deleteProgram(programId) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson("/programs/".concat(encodeURIComponent(programId)), {
        method: 'DELETE'
      })).then(function ($await_29) {
        try {
          response = $await_29;
          // don't hold up response by awaiting
          _clearByKey("program-".concat(programId));
          _clearByKey('programs');
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }

  // Milestones
  function getMilestones(programId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "milestones-".concat(programId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_30) {
        try {
          cached = $await_30;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/milestones?programId=".concat(encodeURIComponent(programId)));
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_31) {
            try {
              response = $await_31;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function saveMilestone(milestone) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson('/milestones', {
        method: 'POST',
        body: JSON.stringify(milestone)
      })).then(function ($await_32) {
        try {
          response = $await_32;
          // don't hold up response by awaiting
          _cacheClearByKeyStartsWith('milestone');
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getMilestone(milestoneId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "milestone-".concat(milestoneId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_33) {
        try {
          cached = $await_33;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/milestones/".concat(encodeURIComponent(milestoneId)));
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_34) {
            try {
              response = $await_34;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function deleteMilestone(milestoneId) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson("/milestones/".concat(encodeURIComponent(milestoneId)), {
        method: 'DELETE'
      })).then(function ($await_35) {
        try {
          response = $await_35;
          // don't hold up response by awaiting
          _cacheClearByKeyStartsWith('milestone');
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }

  // Recipients
  function getRecipients(programId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "recipients-".concat(programId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_36) {
        try {
          cached = $await_36;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/recipients?programId=".concat(encodeURIComponent(programId)));
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_37) {
            try {
              response = $await_37;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function updateRecipient(recipientId, recipient) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson("/recipients/".concat(recipientId), {
        method: 'POST',
        body: JSON.stringify(recipient)
      })).then(function ($await_38) {
        try {
          response = $await_38;
          // don't hold up response by awaiting
          _cacheClearByKeyStartsWith('recipient');
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function updateRecipients(recipientIds, updateObj) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson('/recipients/bulk-update', {
        method: 'POST',
        body: JSON.stringify(_objectSpread({
          recipients: recipientIds
        }, updateObj))
      })).then(function ($await_39) {
        try {
          response = $await_39;
          // don't hold up response by awaiting
          _cacheClearByKeyStartsWith('recipient');
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getRecipient(recipientId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "recipient-".concat(recipientId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_40) {
        try {
          cached = $await_40;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/recipients/".concat(encodeURIComponent(recipientId)));
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_41) {
            try {
              response = $await_41;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getPreferences() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var rosterPersonId, options, key, cached, url, promise, response;
      rosterPersonId = $args.length > 0 && $args[0] !== undefined ? $args[0] : null;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = 'preferences';
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_42) {
        try {
          cached = $await_42;
          if (cached) {
            return $return(cached);
          }
          url = '/preferences';
          if (rosterPersonId) {
            url = "/preferences/".concat(encodeURIComponent(rosterPersonId));
          }
          promise = fetchJson(url);
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_43) {
            try {
              response = $await_43;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function updatePreferences(hasPrivate, allowExternal) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, response;
      options = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      return Promise.resolve(fetchJson('/preferences', {
        method: 'PUT',
        body: JSON.stringify({
          hasPrivateContributions: hasPrivate,
          allowExternalInvitations: allowExternal
        })
      })).then(function ($await_44) {
        try {
          response = $await_44;
          _cacheClearByKeyStartsWith('preferences');
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getCompanyPreferences() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
      key = 'company-preferences';
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_45) {
        try {
          cached = $await_45;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson('/company-preferences');
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_46) {
            try {
              response = $await_46;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function updateCompanyPreferences(preferences) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson('/company-preferences', {
        method: 'PUT',
        body: JSON.stringify(preferences)
      })).then(function ($await_47) {
        try {
          response = $await_47;
          _clearByKey('company-preferences');
          _clearByKey('preferences');
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getRecipientByGiftCodeId(giftCodeId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "recipient-gift-code-".concat(giftCodeId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_48) {
        try {
          cached = $await_48;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/recipient/".concat(encodeURIComponent(giftCodeId)));
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_49) {
            try {
              response = $await_49;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function deleteRecipient(recipientId) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson("/recipients/".concat(encodeURIComponent(recipientId)), {
        method: 'DELETE'
      })).then(function ($await_50) {
        try {
          response = $await_50;
          // don't hold up response by awaiting
          _cacheClearByKeyStartsWith('recipient');
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function deleteRecipients(recipientIds) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson('/recipients/bulk-delete', {
        method: 'POST',
        body: JSON.stringify({
          recipients: recipientIds
        })
      })).then(function ($await_51) {
        try {
          response = $await_51;
          // don't hold up response by awaiting
          _cacheClearByKeyStartsWith('recipient');
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }

  // Award Files
  function getAwardFiles(programId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "award-files-".concat(programId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_52) {
        try {
          cached = $await_52;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/award-files?programId=".concat(encodeURIComponent(programId)));
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_53) {
            try {
              response = $await_53;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function saveAwardFile(awardFile, preview) {
    return new Promise(function ($return, $error) {
      var response;
      return Promise.resolve(fetchJson('/award-files', {
        method: 'POST',
        body: JSON.stringify(_objectSpread(_objectSpread({}, awardFile), {}, {
          preview: !!preview
        }))
      })).then(function ($await_54) {
        try {
          response = $await_54;
          // don't hold up response by awaiting
          _cacheClearByKeyStartsWith('award-files');
          return $return(response);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getAwardFile(awardFileId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "award-file-".concat(awardFileId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_55) {
        try {
          cached = $await_55;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/award-files/".concat(encodeURIComponent(awardFileId)));
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_56) {
            try {
              response = $await_56;
              return $return(_cacheSet(key, response, 60)); //cache for 1 hour
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getAwardFileRecords(awardFileId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "award-file-records-".concat(awardFileId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_57) {
        try {
          cached = $await_57;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/award-files/".concat(encodeURIComponent(awardFileId), "/records"));
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_58) {
            try {
              response = $await_58;
              return $return(_cacheSet(key, response, 60)); //cache for 1 hour
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }

  // Celebration
  function getCelebration(celebrationId, useSharedFallback) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, queryParams, promise, response;
      options = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      key = "celebration-".concat(celebrationId, "-fallback-").concat(useSharedFallback);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_59) {
        try {
          cached = $await_59;
          if (cached) {
            return $return(cached);
          }
          queryParams = '';
          if (useSharedFallback) {
            queryParams = '?useSharedFallback=true';
          }
          promise = fetchJson("/celebration/".concat(encodeURIComponent(celebrationId)).concat(queryParams));
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_60) {
            try {
              response = $await_60;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getCelebrations(startDate, endDate, invited, contributed, limit, cursor, personId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, filter, searchFilter, hasContributedFilter, query, queryString, key, cached, promise, response;
      options = $args.length > 7 && $args[7] !== undefined ? $args[7] : {};
      filter = $args.length > 8 && $args[8] !== undefined ? $args[8] : {};
      searchFilter = $args.length > 9 && $args[9] !== undefined ? $args[9] : {};
      hasContributedFilter = $args.length > 10 ? $args[10] : undefined;
      query = [];
      if (startDate) {
        query.push("startDate=".concat(encodeURIComponent(startDate)));
      }
      if (endDate) {
        query.push("endDate=".concat(encodeURIComponent(endDate)));
      }
      if (invited) {
        query.push("invited=".concat(encodeURIComponent(invited)));
      }
      if (contributed) {
        query.push("contributed=".concat(encodeURIComponent(contributed)));
      }
      if (limit) {
        query.push("limit=".concat(encodeURIComponent(limit)));
      }
      if (cursor) {
        query.push("cursor=".concat(encodeURIComponent(cursor)));
      }
      if (filter) {
        query.push("filter=".concat(encodeURIComponent(filter)));
      }
      if (searchFilter) {
        query.push("searchFilter=".concat(encodeURIComponent(JSON.stringify(searchFilter))));
      }
      if (hasContributedFilter !== undefined) {
        query.push("hasContributedFilter=".concat(!!hasContributedFilter));
      }
      queryString = query.join('&');
      key = "celebrations-".concat(queryString, "-person-").concat(personId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_61) {
        try {
          cached = $await_61;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/celebrations?".concat(queryString));
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_62) {
            try {
              response = $await_62;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function searchCelebrations() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var filter, options, key, cached, promise, response;
      filter = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "search-celebrations-".concat(JSON.stringify(filter));
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_63) {
        try {
          cached = $await_63;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson('/celebrations/search', {
            method: 'POST',
            body: JSON.stringify(filter)
          });
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_64) {
            try {
              response = $await_64;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function searchCelebrationsAdmin() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var filter, options, key, cached, promise, response;
      filter = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "search-celebrations-admin-".concat(JSON.stringify(filter));
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_65) {
        try {
          cached = $await_65;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson('/celebrations/admin/search', {
            method: 'POST',
            body: JSON.stringify(filter)
          });
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_66) {
            try {
              response = $await_66;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getPersonCelebrations(personId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 1 && $args[1] !== undefined ? $args[1] : {};
      key = "person-celebrations-".concat(personId);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_67) {
        try {
          cached = $await_67;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson('/persons/celebrations');
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_68) {
            try {
              response = $await_68;
              return $return(_cacheSet(key, response));
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function createBulkContributorByRosterPersonId(bulkContributionGroupId, selectedCelebrationSiteIds) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options;
      options = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      return Promise.resolve(fetchJson("/celebration/contributors/bulk-contribution/".concat(encodeURIComponent(bulkContributionGroupId)), {
        method: 'POST',
        body: JSON.stringify({
          selectedCelebrationSiteIds: selectedCelebrationSiteIds
        })
      })).then($return, $error);
    });
  }

  // Procedures
  function sendManagerEmails() {
    return fetchJson('/run/send-celebration-manager-emails', {
      method: 'POST'
    });
  }
  function sendAwardEmails() {
    return fetchJson('/run/send-recipient-emails', {
      method: 'POST'
    });
  }
  function sendAwardEmail(recipientId) {
    return fetchJson("/recipients/".concat(encodeURIComponent(recipientId), "/emails/recipient"), {
      method: 'POST'
    });
  }
  function sendAwardReminderEmails() {
    return fetchJson('/run/send-reminder-emails', {
      method: 'POST'
    });
  }
  function sendAwardReminderEmail(recipientId) {
    return fetchJson("/recipients/".concat(encodeURIComponent(recipientId), "/emails/reminder"), {
      method: 'POST'
    });
  }
  function sendAwardExpirationEmails() {
    return fetchJson('/run/send-expiration-emails', {
      method: 'POST'
    });
  }
  function sendAwardExpirationEmail(recipientId) {
    return fetchJson("/recipients/".concat(encodeURIComponent(recipientId), "/emails/expiration"), {
      method: 'POST'
    });
  }
  function awardRecipients() {
    return fetchJson('/run/award-recipient', {
      method: 'POST'
    });
  }
  function awardRecipient(recipientId) {
    return fetchJson("/recipients/".concat(encodeURIComponent(recipientId), "/awards"), {
      method: 'POST'
    });
  }

  // Site URLs
  function getWebappUrl(identifierList) {
    if (Array.isArray(identifierList)) {
      return identifierList.find(function (id) {
        return (id || '').toLowerCase().indexOf('myawardsite.com') >= 0;
      });
    } else {
      return '';
    }
  }
  function getCelebrationSiteUrl(identifierList, celebrationId) {
    if (celebrationId) {
      return "".concat(getWebappUrl(identifierList), "/celebration/").concat(celebrationId);
    } else {
      return '';
    }
  }
  function getContributionSiteUrl(identifierList, celebrationSiteId) {
    if (celebrationSiteId) {
      return "".concat(getWebappUrl(identifierList), "/contribute/").concat(celebrationSiteId);
    } else {
      return '';
    }
  }
  function getServiceAwardsSite(celebrationSiteId) {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var rosterPersonId, options, personKey, key, cached, promise, response;
      rosterPersonId = $args.length > 1 && $args[1] !== undefined ? $args[1] : null;
      options = $args.length > 2 && $args[2] !== undefined ? $args[2] : {};
      personKey = rosterPersonId ? "-".concat(rosterPersonId) : '';
      key = "service-awards-site-".concat(celebrationSiteId).concat(personKey);
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_70) {
        try {
          cached = $await_70;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson("/celebration/".concat(encodeURIComponent(celebrationSiteId), "/sites/service-awards"), {
            method: 'POST'
          });
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_71) {
            try {
              response = $await_71;
              return $return(_cacheSet(key, response, 60)); //cache for 1 hour
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function createOrUpdateDeviceToken(personId, deviceToken) {
    var request = {
      personId: personId,
      deviceToken: deviceToken
    };
    return fetchJson('/notifications/device-token', {
      method: 'POST',
      body: JSON.stringify(request)
    });
  }
  function sendContributorThankYouNotification(celebrationId, commentId) {
    var request = {
      commentId: commentId,
      celebrationId: celebrationId
    };
    return fetchJson('/celebration/send/contributor-thank-you-email', {
      method: 'POST',
      body: JSON.stringify(request)
    });
  }
  function sendCommentEmail(celebrationId, commentId, type) {
    return fetchJson('/celebration/send/comment-email', {
      method: 'POST',
      body: JSON.stringify({
        celebrationId: celebrationId,
        commentId: commentId,
        type: type
      })
    });
  }

  // Reports
  function getReportData(reportType, options) {
    var url = "/report/".concat(encodeURIComponent(reportType));
    var qry = Object.keys(options).filter(function (key) {
      return !!options[key];
    }).map(function (key) {
      return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(options[key]));
    }).join('&');
    if (qry !== '') {
      url = "".concat(url, "?").concat(qry);
    }
    return fetchJson(url, {
      method: 'GET'
    });
  }
  function getReportFilterOptions() {
    var $args = arguments;
    return new Promise(function ($return, $error) {
      var options, key, cached, promise, response;
      options = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
      key = 'report-filter-options';
      return Promise.resolve(_cacheGet(key, options)).then(function ($await_72) {
        try {
          cached = $await_72;
          if (cached) {
            return $return(cached);
          }
          promise = fetchJson('/report/filter-options');
          _cacheSetPromise(key, promise);
          return Promise.resolve(promise).then(function ($await_73) {
            try {
              response = $await_73;
              return $return(_cacheSet(key, response, 60 * 24)); //cache for 1 day
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }, $error);
    });
  }
  function getAuthenticatedPerson() {
    return fetchJson('/persons');
  }

  // Public
  return {
    getContributors: getContributors,
    getContributorsInvitationDate: getContributorsInvitationDate,
    getInvitee: getInvitee,
    addContributorsToCelebrationFromEmail: addContributorsToCelebrationFromEmail,
    addContributorsToCelebrationFromRosterId: addContributorsToCelebrationFromRosterId,
    createOrUpdateContributor: createOrUpdateContributor,
    acceptTermsAndConditions: acceptTermsAndConditions,
    createOrUpdateCelebrationReplies: createOrUpdateCelebrationReplies,
    deleteCelebrationReplies: deleteCelebrationReplies,
    getPrograms: getPrograms,
    saveProgram: saveProgram,
    getProgram: getProgram,
    deleteProgram: deleteProgram,
    getMilestones: getMilestones,
    saveMilestone: saveMilestone,
    getMilestone: getMilestone,
    deleteMilestone: deleteMilestone,
    getRecipients: getRecipients,
    updateRecipient: updateRecipient,
    updateRecipients: updateRecipients,
    getRecipient: getRecipient,
    getRecipientByGiftCodeId: getRecipientByGiftCodeId,
    deleteRecipient: deleteRecipient,
    deleteRecipients: deleteRecipients,
    getPreferences: getPreferences,
    updatePreferences: updatePreferences,
    getCompanyPreferences: getCompanyPreferences,
    updateCompanyPreferences: updateCompanyPreferences,
    getAwardFiles: getAwardFiles,
    saveAwardFile: saveAwardFile,
    getAwardFile: getAwardFile,
    getAwardFileRecords: getAwardFileRecords,
    getCelebration: getCelebration,
    getCelebrations: getCelebrations,
    searchCelebrations: searchCelebrations,
    searchCelebrationsAdmin: searchCelebrationsAdmin,
    getPersonCelebrations: getPersonCelebrations,
    sendManagerEmails: sendManagerEmails,
    sendAwardEmails: sendAwardEmails,
    sendAwardEmail: sendAwardEmail,
    sendAwardReminderEmails: sendAwardReminderEmails,
    sendAwardReminderEmail: sendAwardReminderEmail,
    sendAwardExpirationEmails: sendAwardExpirationEmails,
    sendAwardExpirationEmail: sendAwardExpirationEmail,
    awardRecipients: awardRecipients,
    awardRecipient: awardRecipient,
    getCelebrationSiteUrl: getCelebrationSiteUrl,
    getContributionSiteUrl: getContributionSiteUrl,
    getServiceAwardsSite: getServiceAwardsSite,
    createOrUpdateDeviceToken: createOrUpdateDeviceToken,
    sendContributorThankYouNotification: sendContributorThankYouNotification,
    sendCommentEmail: sendCommentEmail,
    getReportData: getReportData,
    getReportFilterOptions: getReportFilterOptions,
    getAuthenticatedPerson: getAuthenticatedPerson,
    createBulkContributorByRosterPersonId: createBulkContributorByRosterPersonId
  };
}
var noCache = {
  getKey: function getKey() {
    return '';
  },
  get: function get() {
    return new Promise(function ($return, $error) {
      return $return(undefined);
    });
  },
  set: function set(_ref) {
    var key = _ref.key,
      value = _ref.value,
      lifetimeMins = _ref.lifetimeMins;
    return value;
  },
  clear: function clear() {
    return undefined;
  },
  clearByKey: function clearByKey() {
    return undefined;
  },
  clearByKeyStartsWith: function clearByKeyStartsWith() {
    return undefined;
  }
};
function _default(url, customFetch) {
  var cacheInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noCache;
  var ignorePromises = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var cacheDurationMinutes = arguments.length > 4 ? arguments[4] : undefined;
  if (typeof customFetch !== 'function') {
    throw new Error("".concat(_typeof(customFetch), " is not a function"));
  }
  return new SDK(url, customFetch, cacheInterface, ignorePromises, cacheDurationMinutes);
}
//# sourceMappingURL=index.js.map